
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/App.css';
import createRoutes from './routes';

function App() {
  return (
    createRoutes()
  );
}

export default App;
